import React, { useState, useEffect } from "react";
import {Container, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getUserType } from "../../Helpers/Utils/Common";
import { get_all_user } from "../../Helpers/API/formsAPI";

function MayaGoogleForm({ navigation, primaryDetails, setPrimaryDetails }) {
  const user_type = getUserType();
  const navigate = useNavigate();

  // Helper functions to get current date and time
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
  };

  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // Format: HH:MM
  };

  // Set current date and time on component mount if not already set
  useEffect(() => {
    if (!primaryDetails.visit_date || !primaryDetails.visit_time) {
      setPrimaryDetails(prev => ({
        ...prev,
        visit_date: prev.visit_date || getCurrentDate(),
        visit_time: prev.visit_time || getCurrentTime()
      }));
    }
  }, []);

  // Fetch TAS users from database
  useEffect(() => {
    const fetchTasUsers = async () => {
      try {
        const response = await get_all_user();
        if (response.data && response.data.success && response.data.data) {
          setTasUsers(response.data.data);
        } else {
          setTasUsers([]);
        }
      } catch (error) {
        console.error('Error fetching TAS users:', error);
        setTasUsers([]);
      }
    };

    fetchTasUsers();
  }, []);

  const [isError, setIsError] = useState({
    visit_date: false,
    visit_time: false,
    activity_name: false,
    tas: false,
  });

  // const TAS_NAMES = [
  //   "Agento Estrada",
  //   "Alexis Buan",
  //   "Alfuro Magbanua",
  //   "Allan Almeza",
  //   "Angelo Pantoja"
  // ];

  const [tasUsers, setTasUsers] = useState([]);

  const ACTIVITY_OPTIONS = [
    { value: "BAU", label: "BAU" },
    { value: "TAM", label: "TAM" },
    { value: "CIP", label: "CIP" },
    // { value: "TAM & CIP", label: "TAM & CIP" },
   
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const handleTASSelection = (selectedOption) => {
    setPrimaryDetails(prev => ({ ...prev,
      tas: selectedOption ? selectedOption.value : '',
    }));
    if (isError.tas) {
      setIsError({
        ...isError,
        tas: false,
      });
    }
  };

  // const handleTASSelection = (e) => {
  //   const { value } = e.target;
  //   setPrimaryDetails({
  //     ...primaryDetails,
  //     tas: value,
  //   });
  //   if (isError.tas) {
  //     setIsError({
  //       ...isError,
  //       tas: false,
  //     });
  //   }
  // };

  const handleActivityChange = (e) => {
    const { value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      activity_name: value,
    }));
    if (isError.activity_name) {
      setIsError({
        ...isError,
        activity_name: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      visit_date: !primaryDetails.visit_date,
      visit_time: !primaryDetails.visit_time,
      activity_name: !primaryDetails.activity_name,
      tas: !primaryDetails.tas,
    };
    setIsError(errors);
    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.visit_date &&
      !!primaryDetails.visit_time &&
      !!primaryDetails.activity_name &&
      !!primaryDetails.tas;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      navigation.next();
    }
  };

  const handleBackToDashboard = () => {
    const hasData = primaryDetails.visit_date ||
      primaryDetails.visit_time ||
      primaryDetails.activity_name ||
      primaryDetails.tas;

    if (hasData) {
      const confirmLeave = window.confirm(
        "Are you sure you want to go back to the dashboard? Any unsaved data will be lost."
      );
      if (confirmLeave) {
        navigate('/timein');
      }
    } else {
      navigate('/timein');
    }
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          <Col md={10}>
              <div className="form-main-header">
                  <h5 className="form-title">Engagement Visit Details</h5>
                  <p className="form-desc">Complete the form below to register your visit details</p>
              </div>

              <div className="form-progress-bar">
                <div className="form-progress-status">
                  {/* <div className="form-progress-dot"></div> */}
                  {/* Progress automatically saved */}
                </div>
                <button
                  onClick={() => {
                    if (navigation.clearFormData) {
                      if (window.confirm('Are you sure you want to clear all form data and start over?')) {
                        navigation.clearFormData();
                        window.location.reload();
                      }
                    }
                  }}
                  className="form-clear-btn"
                >
                  Clear Form
                </button>
              </div>
              <div className="form-content">
                <div className="mb-5">
                  <h6 className="form-label">
                    Name of Trade Assurance Specialist (TAS)
                    <span className="form-required">*</span>
                  </h6>
                  <Select
                    name="tas"
                    value={tasUsers.find(user => (user.name || user.full_name) === primaryDetails.tas) ? 
                      { value: primaryDetails.tas, label: primaryDetails.tas } : null}
                    onChange={handleTASSelection}
                    options={tasUsers.map((user, index) => ({
                      value: user.name || user.full_name,
                      label: user.name || user.full_name,
                      key: `tas-${index}-${user.id || user.name}`
                    }))}
                    placeholder="Select a Trade Assurance Specialist"
                    isSearchable={true}
                    isClearable={true}
                    className={`react-select-container ${isError.tas ? 'is-invalid' : ''}`}
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: isError.tas ? '#dc3545' : provided.borderColor,
                        '&:hover': {
                          borderColor: isError.tas ? '#dc3545' : provided.borderColor,
                        },
                        boxShadow: state.isFocused && isError.tas ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : provided.boxShadow
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999
                      })
                    }}
                  />
                  {isError.tas && (
                    <div className="form-error">
                      Please select a Trade Assurance Specialist
                    </div>
                  )}
                  <div>
                    <p className="form-note-text">
                      <em>Note: Choose Name</em>
                    </p>
                  </div>
                </div>

                {/* Visit Details Section */}
                <div className="mb-4">
                  <h6 className="form-label">Visit Details</h6>
                  <p className="form-desc">
                    Please specify when the visit took place
                  </p>
                  <Form>
                    <Form.Group className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Form.Label className="form-label mb-0">
                          Date of Visit <span className="form-required">*</span>
                        </Form.Label>
                        <button
                          type="button"
                          onClick={() => setPrimaryDetails(prev => ({ ...prev, visit_date: getCurrentDate() }))}
                          className="btn btn-sm btn-outline-primary"
                        >
                          Set Current Date
                        </button>
                      </div>
                      <Form.Control
                        type="date"
                        name="visit_date"
                        value={primaryDetails.visit_date || ""}
                        onChange={handleInputChange}
                        isInvalid={isError.visit_date}
                        className="form-input"
                      />
                      {isError.visit_date && (
                        <div className="form-error">
                          Date of visit is required
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Form.Label className="form-label mb-0">
                          Start Time of Visit <span className="form-required">*</span>
                        </Form.Label>
                        <button
                          type="button"
                          onClick={() => setPrimaryDetails(prev => ({ ...prev, visit_time: getCurrentTime() }))}
                          className="btn btn-sm btn-outline-primary"
                        >
                          Set Current Time
                        </button>
                      </div>
                      <Form.Control
                        type="time"
                        name="visit_time"
                        value={primaryDetails.visit_time || ""}
                        onChange={handleInputChange}
                        isInvalid={isError.visit_time}
                        className="form-input"
                      />
                      {isError.visit_time && (
                        <div className="form-error">
                          Time of visit is required
                        </div>
                      )}
                    </Form.Group>
                  {/* Activity Name Selection */}
                    <div className="mb-4">
                      <h6 className="form-label">
                        Activity Name
                        <span className="form-required">*</span>
                      </h6>
                      <div className="form-radio-group">
                        {ACTIVITY_OPTIONS.map((option, index) => (
                          <div
                            key={`activity-${index}-${option.value}`}
                            className={`form-radio-item ${primaryDetails.activity_name === option.value ? "selected" : ""}`}
                          >
                            <div className="form-radio-flex">
                              <Form.Check
                                type="radio"
                                name="activity_name"
                                value={option.value}
                                label={option.label}
                                onChange={handleActivityChange}
                                checked={primaryDetails.activity_name === option.value}
                                className="form-radio"
                              />
                            </div>
                          </div>
                        ))}
                        {isError.activity_name && (
                          <div className="form-error">
                            Please select an activity
                          </div>
                        )}
                      </div>
                      <div>
                        <p className="form-note-text">
                          <em>Note: Choose Activity Name</em>
                        </p>
                      </div>
                    </div>
                    <div className="form-btn-row">
                      <AppButton
                        onClick={handleBackToDashboard}
                        variant="back"
                        className="form-btn variant-secondary"
                      >
                        ← Back
                      </AppButton>
                      <AppButton
                        onClick={handleSubmit}
                        variant="next"
                        className="form-btn variant-primary"
                        disabled={!isFormValid()}
                      >
                        Next →
                      </AppButton>
                    </div>
                  </Form>
                </div>
              </div>
            
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MayaGoogleForm;
// ...existing code...